export default __webpack_public_path__ + "static/dratini-53211f2685d697c157cd885d584620e6.png";